import { createListModalContainer } from 'factories/ListModal'
import actions from 'actions/users'
import Component from 'components/Users/Select'

export default createListModalContainer({ actions })(Component)
